import { HTTP } from '../../../http-common';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';
import { Teams } from '../../../models/Teams';
import { TeamsRow } from '../../../models/TeamsRow';

const state = {
  teams: new Teams(),
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  addRow(state, teams) {
    state.teams.teamsRows.push(teams);
  },
  clearRows(state) {
    state.teams = new Teams();
    state.teams.teamsRows = [];
    state.teams.teamsRows.length = 0;
    state.teams.teamsRows.push(new TeamsRow());
    state.message = new httpError();
  },
  removeTeams(state, rows) {
    if (state.teams.teamsRows.length > 0) {
      for (var index = state.teams.teamsRows.length; index--; ) {
        if (
          rows.includes(
            (x) => x.extension == state.teams.teamsRows[index].extension
          )
        ) {
          state.teams.teamsRows.splice(index, 1);
        }
      }
    }
  },
  setProgress(state, message) {
    state.message = message;
  },
  setConfigType(state, type) {
    state.teams.configType = type;
  },
  setOnGoingTeamConfig(state, val) {
    state.teams.hasOnGoingTeamConfig = val;
  },
  setRows(state, teams) {
    state.teams.teamsRows.length = 0;
    state.teams.teamsRows = teams;
  },
  setTeams(state, teams) {
    state.teams = teams;
  },
  deleteRow(state) {
    state.teams.teamsRows.pop();
  },
  removeHardware(state) {
    state.teams.hardware = 'none';
  },
  changeQuantity(state, quantity) {
    state.teams.teamsRows[0].quantity = quantity;
  },
  removeTeamsRow(state, index) {
    state.teams.teamsRows.splice(index, 1);
  },
  updateField,
};

//ACTIONS
const actions = {
  addRow({ state, commit }, isQantas) {
    var length = state.teams.teamsRows[0]
      ? state.teams.teamsRows[0].contractLength
      : isQantas
      ? 36
      : 0;
    let teamRow = new TeamsRow({
      id: state.teams.teamsRows.length + 1,
      contractLength: length,
      handsetID: 0,
    });
    commit('addRow', teamRow);
  },
  reset({ commit }) {
    commit('clearRows');
  },
  removeHardware({ commit }) {
    commit('removeHardware');
  },
  populateTeams({ commit, dispatch, rootState }, isQantas) {
    return new Promise((resolve, reject) => {
      dispatch('setMessage', new httpError());
      var response = HTTP.get(
        'order/GetTeamsOnOrder/' + rootState.orders.rows[0].orderID
      );
      response
        .then(function (data) {
          if (data.status === 200) {
            commit('setTeams', data.data);
            dispatch(
              'setMessage',
              new httpError({ message: 'Retrieved OK', httpStatus: 200 })
            );
          }
          if (data.status === 204) {
            commit(
              'setTeams',
              new Teams({
                connectionType: 'extension',
                orderID: rootState.orders.rows[0].orderID,
                teamsRows: [
                  new TeamsRow({
                    extension: 500,
                    contractLength: isQantas ? 36 : 12,
                  }),
                ],
              })
            );
          }
          resolve(data.data);
        })
        .catch(function (err) {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error' + err.message, httpStatus: 500 })
          );

          reject(err);
        });
    });
  },
  updateRows({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'order/UpdateTeamsOnOrder/' + rootState.orders.rows[0].orderID,
        state.teams
      );
      response
        .then((data) => {
          if (data.status == 200) {
            commit('setTeams', data.data);
            dispatch(
              'setMessage',
              new httpError({ message: 'Saved OK', httpStatus: 200 })
            );
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  removeRows({ state, commit, dispatch }, newVal) {
    return new Promise((resolve) => {
      var oldVal = 0 || state.teams.teamsRows.length;
      var rows = [];
      for (var i = oldVal; i > newVal; i--) {
        if (state.teams.teamsRows[i - 1].id > 0)
          rows.push(state.teams.teamsRows[i - 1]);
        commit('deleteRow');
      }
      // dispatch('persistRows', rows).then((data) => {
      //   resolve(data);
      // });
    });
  },
  removeTeamsFromOrder({ state, dispatch }, teamsID) {
    return new Promise((resolve, reject) => {
      if (teamsID && teamsID > 0) {
        HTTP.post(`Order/DeleteTeamsFromOrder/${state.teams.orderID}`, teamsID)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            dispatch(
              'setMessage',
              new httpError({
                message: err.message,
                httpStatus: 500,
              })
            );
            reject(err);
          });
      }
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
